module.exports = __webpack_public_path__ + "static/media/iReform_portfolio_image.4d12b49d.jpg";